// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3ie8U","containerItemsCenter":"Skeleton_containerItemsCenter__upxm9"};